export default __webpack_public_path__ + "static/media/exclusive-china-town-district.0bfc9ef7.png";